/* ============================================================
 * Normalización de móviles chilenos (misma regla que el backend).
 *
 * El backend guarda siempre el formato E.164 (+569XXXXXXXX), pero el
 * operador escribe el número como se lo dictan: con espacios, con el
 * prefijo o sin él. Comparar el texto crudo con lo guardado haría que un
 * cliente existente no se reconociera y se tratara como nuevo, y luego el
 * alta fallaría por duplicado sin que se entienda por qué.
 *
 * Esto NO es validación de seguridad: el backend valida igualmente y no se
 * fía de lo que llegue. Aquí solo sirve para reconocer a quien ya está.
 * ============================================================ */

export function normTel(entrada) {
  const d = String(entrada || '').replace(/\D/g, '');
  let n = null;
  if (d.length === 11 && d.startsWith('569')) n = '+' + d;
  else if (d.length === 9 && d.startsWith('9')) n = '+56' + d;
  else if (d.length === 8) n = '+569' + d;
  return n && /^\+569\d{8}$/.test(n) ? n : null;
}

/** Para mostrar: +56 9 8765 4321 */
export function formatearTel(e164) {
  const m = /^\+569(\d{4})(\d{4})$/.exec(e164 || '');
  return m ? `+56 9 ${m[1]} ${m[2]}` : (e164 || '');
}
